/**
 * Runtime configuration helper for K8s/Docker deployment.
 *
 * In K8s, environment variables are injected at runtime via env.js (window.ENV).
 * During local development with react-scripts, variables come from process.env.
 *
 * This helper checks window.ENV first (runtime), then falls back to process.env (build-time).
 */
export const getConfig = (key) => {
  if (
    typeof window !== "undefined" &&
    window.ENV &&
    window.ENV[key] !== undefined
  ) {
    return window.ENV[key];
  }
  return process.env[key];
};

export default getConfig;
